import { useCallback } from 'react'
import { type XYPosition, useReactFlow } from '@xyflow/react'
import {
  BuilderNode,
  BuilderNodeType,
} from '@/features/flow/_builder/components/blocks/types'
import { createNodeWithDefaultData } from '@/features/flow/_builder/components/blocks/utils'

export function useInsertNode() {
  const { addNodes, screenToFlowPosition, getNodes, updateNode } =
    useReactFlow()

  return useCallback(
    (type: BuilderNodeType, pos?: XYPosition) => {
      if (type === BuilderNode.START || type === BuilderNode.END) {
        const existing = getNodes().find((n) => n.type === type)
        if (existing) return existing
      }

      const _pos =
        pos ||
        screenToFlowPosition({
          x: window.innerWidth / 2,
          y: window.innerHeight / 2,
        })

      getNodes().forEach((node) => {
        if (node.selected) {
          updateNode(node.id, { selected: false })
        }
      })

      const newNode = createNodeWithDefaultData(type, {
        position: _pos,
        selected: true,
      })
      addNodes(newNode)

      return newNode
    },
    [screenToFlowPosition, getNodes, addNodes, updateNode]
  )
}
